
export type Items = {
  subproject: false,
  stakeholder: false,
  issue: false,
  complaints: false,
  requirements: false,
  activity: false,
  physical: false,
  regulatory: false,
  political: false,
  social: false,
  emotional: false
  ctx_stakeholders: false,
  ctx_issues: false,
  contactpersons: false,
  ctx_requirements: false,
  contactmoments: false,
  permits: false,
  contents: false,
  ctx_activities: false,
  ctx_complaints: false
}
const itemsIcons = {
  subproject: '/assets/png/subproject.png',
  stakeholder: '/assets/png/stakeholders.png',
  stakeholder_strategic: '/assets/png/stakeholders.png',
  issue: '/assets/png/issues.png',
  complaints: '/assets/png/complaints.png',
  requirements: '/assets/png/requirements.png',
  activity: '/assets/png/calendars.png',
  physical: '/assets/png/physical.png',
  regulatory: '/assets/png/regulatory.png',
  political: '/assets/png/political.png',
  social: '/assets/png/social.png',
  emotional: '/assets/png/emotional.png',
  ctx_stakeholders: '/assets/png/stakeholders_ctx.png', 
  ctx_issues: '/assets/png/issues_ctx.png', 
  contactpersons: '/assets/png/contactpersons.png',  
  ctx_requirements: '/assets/png/requirements_ctx.png', 
  contactmoments: '/assets/png/contactmoments.png', 
  permits: '/assets/png/permits_ctx.png',
  contents: '/assets/png/document.png', 
  ctx_activities: '/assets/png/activities.png', 
  ctx_complaints: '/assets/png/complaints_ctx.png'
}
const itemsStatus = {
  stakeholder: [
    { name: 'Samenwerken', filter: 'Samenwerken', icon: '/assets/png/stakeholders-cooperate.png' },
    { name: 'Tevreden houden', filter: 'Tevreden houden', icon: '/assets/png/stakeholders-keepsatisfied.png' },
    { name: 'Informeren', filter: 'Informeren', icon: '/assets/png/stakeholders-inform.png' },
    { name: 'Monitoren', filter: 'Monitoren', icon: '/assets/png/stakeholders-monitor.png' },
    { name: 'Ongecategoriseerd', filter: 'Ongecategoriseerd', icon: '/assets/png/stakeholders.png' },
  ],
  stakeholder_strategic: [
    { name: 'Reactief', filter: 'Reactief', icon: '/assets/png/stakeholders-reactive.png' },
    { name: 'Informeren', filter: 'Informeren', icon: '/assets/png/stakeholders-inform-strategic.png' },
    { name: 'Adviseren', filter: 'Adviseren', icon: '/assets/png/stakeholders-advice.png' },
    { name: 'Raadplegen', filter: 'Raadplegen', icon: '/assets/png/stakeholders-consult.png' },
    { name: 'Coproduceren', filter: 'Coproduceren', icon: '/assets/png/stakeholders-coproduce.png' },
    { name: 'Meebeslissen', filter: 'Meebeslissen', icon: '/assets/png/stakeholders-codecide.png' },
    { name: 'Ongecategoriseerd', filter: 'Ongecategoriseerd', icon: '/assets/png/stakeholders-none.png' },
  ],
  issue: [
    { name: 'Zeer hoog', filter: 'very-high', icon: '/assets/png/issues-very-high.png' },
    { name: 'Hoog', filter: 'high', icon: '/assets/png/issues-high.png' },
    { name: 'Midden', filter: 'middle', icon: '/assets/png/issues-medium.png' },
    { name: 'Laag', filter: 'low', icon: '/assets/png/issues-low.png' },
  ],
  requirements: [
    { name: 'Initieel', filter: 'initial', icon: '/assets/png/requirements-open.png' },
    { name: 'evaluation', filter: 'evaluation', icon: '/assets/png/requirements-open.png' },
    { name: 'Gehonoreerd', filter: 'gehonoreerd', icon: '/assets/png/requirements-honoured.png' },
    { name: 'Afgewezen', filter: 'afgewezen', icon: '/assets/png/requirements-rejected.png' },
    { name: 'Vervallen', filter: 'expired', icon: '/assets/png/requirements-expired.png' },
    { name: 'Volgende fase', filter: 'next_phase', icon: '/assets/png/requirements-next_phase.png' },
  ],
  complaints: [
    { name: 'Open', filter: 'open', icon: '/assets/png/complaints-open.png' },
    { name: 'In behandeling', filter: 'pending', icon: '/assets/png/complaints-open.png' },
    { name: 'Afgehandeld', filter: 'closed', icon: '/assets/png/complaints-closed.png' },
  ],
  subproject: [],
  activity: [],
  physical: [],
  regulatory: [],
  political: [],
  social: [],
  emotional: [],
  ctx_stakeholders: [],
  ctx_issues: [],
  contactpersons: [],
  ctx_requirements: [],
  contactmoments: [],
  permits: [],
  contents: [],
  ctx_activities: [],
  ctx_complaints: []
}
export function getItemStatusMapToggles(type, stakeholder_strategic=false) {
  // stakeholder_strategic = this.globals.projectConfigs['project.stakeholder_strategy.is_new'];
  const item = [
    {
      name: type,
      is_active: false,
      icon: itemsIcons[(type === 'stakeholder' && stakeholder_strategic === true)? 'stakeholder_strategic' : type],
      status: [],
      sublayerExist: type == 'activity' ? false : true
    }];
  item.map(el => {
    if (itemsStatus[type].length) {
      itemsStatus[(type === 'stakeholder' && stakeholder_strategic === true) ? 'stakeholder_strategic' : type].forEach(status => {
        el.status.push(
          {
            name: status.name,
            is_active: false,
            filter: status.filter,
            icon: status.icon
          }
        );
      });
    }
  })
  return item[0];
}
export const itemsFilterStatus = {
  issues: [
    { name: 'Open', filter: 'open', icon: '/assets/png/complaints-open.png' },
    { name: 'Gesloten', filter: 'gesloten', icon: '/assets/png/complaints-closed.png' },
  ],
  requirements: [
    { name: 'Initieel', filter: 'initial', icon: '/assets/png/requirements-open.png' },
    { name: 'Evaluation', filter: 'evaluation', icon: '/assets/png/requirements-open.png' },
    { name: 'Gehonoreerd', filter: 'gehonoreerd', icon: '/assets/png/requirements-honoured.png' },
    { name: 'Afgewezen', filter: 'afgewezen', icon: '/assets/png/requirements-rejected.png' },
    { name: 'Vervallen', filter: 'expired', icon: '/assets/png/requirements-expired.png' },
    { name: 'Volgende fase', filter: 'next_phase', icon: '/assets/png/requirements-next_phase.png' },
  ],
  complaints: [
    { name: 'Open', filter: 'open', icon: '/assets/png/complaints-open.png' },
    { name: 'In behandeling', filter: 'pending', icon: '/assets/png/complaints-pending.png' },
    { name: 'Afgehandeld', filter: 'closed', icon: '/assets/png/complaints-closed.png' },
  ],
  tasks: [
    { name: 'Recover', filter: true, icon: '/assets/png/complaints-open.png' },
    { name: 'Resolve', filter: false, icon: '/assets/png/complaints-closed.png' },
  ],
}
export function getFilterType(item): string{
  switch(item){
    case 'complaints':
      return 'status'
    case 'requirements':
      return 'status'
    case 'tasks':
      return 'handled'
    case 'issues':
      return 'issues_status'
  }
}
